import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import theme from 'shared/styles/theme';

const PaymentTransferring = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'paymentConfirmation',
  });
  return (
    <View style={styles.container}>
      <View style={styles.loadingContainer}>
        <LoadingSpinner />
      </View>
      <TitleSmText numberOfLines={1}>
        {translatedText('transferring')}
      </TitleSmText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  loadingContainer: {
    alignItems: 'center',
    height: theme.spacing.xxl,
    justifyContent: 'center',
    paddingBottom: theme.spacing.m,
    width: theme.spacing.xxl,
  },
});

export default PaymentTransferring;
